import { render, staticRenderFns } from "./modelPerformance.vue?vue&type=template&id=78dab6d4&scoped=true"
import script from "./modelPerformance.vue?vue&type=script&lang=js"
export * from "./modelPerformance.vue?vue&type=script&lang=js"
import style0 from "./modelPerformance.vue?vue&type=style&index=0&id=78dab6d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dab6d4",
  null
  
)

export default component.exports